<template>
    <div class="bread-box" v-if="!vuex_h5">
        <div class="bread-inner" :class="{ right: type == 'right' }">
            <div class="text" @click="goPage(options[0])" v-if="options[0]">{{ options[0].title }}</div>

            <img src="@/assets/img/mine/go.png" class="goIcon" v-if="options[1]" alt="" />
            <div class="text" @click="goPage(options[1])" :class="{ text2: !options[2] }" v-if="options[1]">{{ options[1].title }}</div>

            <img src="@/assets/img/mine/go.png" class="goIcon" v-if="options[2]" alt="" />
            <div class="text" @click="goPage(options[2])" :class="{ text2: !options[3] }" v-if="options[2]">{{ options[2].title }}</div>

            <img src="@/assets/img/mine/go.png" class="goIcon" v-if="options[3]" alt="" />
            <div class="text" @click="goPage(options[3])" :class="{ text2: !options[4] }" v-if="options[3]">{{ options[3].title }}</div>

            <img src="@/assets/img/mine/go.png" class="goIcon" v-if="options[4]" alt="" />
            <div class="text2" @click="goPage(options[4])" v-if="options[4]">{{ options[4].title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'page-bread',
    components: {},
    props: {
        option: {
            required: false,
            default() {
                return [{}]
            },
        },
        type: {
            required: false,
            default: 'left',
        },
    },
    computed: {},
    data() {
        return {
            options: [],
        }
    },
    watch: {
        option: {
            immediate: true,
            handler(newV) {
                this.options = newV
            },
        },
    },
    mounted() {},
    methods: {
        goPage(item) {
            if (item.path) {
                this.$router.push(item.path)
            }
        },
    },
}
</script>

<style scoped lang="less">
.text {
    font-size: 16px;
    line-height: 16px;
    color: #555555;
    cursor: pointer;
}

.goIcon {
    width: 8px;
    display: block;
    margin: 0 14px;
}

.text2 {
    font-size: 16px;
    line-height: 16px;
    text-decoration: underline;
    color: #000000;
    cursor: pointer;
}

.bread-box {
    padding: 0px 0;

    .bread-inner {
        .flex();
        margin: 0 auto;
        max-width: @width;
        // width: 95%;

        &.right {
            justify-content: flex-end !important;
        }

        a {
            display: inline-flex;
            align-items: center;

            // font-weight: bold;
            font-size: 15px;
            color: #999999;

            img {
                margin-right: 10px;
            }
        }

        .link {
            // font-weight: bold;
            font-size: 15px;
            color: #999999;
        }

        .route-link {
            // font-weight: bold;
            font-size: 15px;
            color: #999999;
        }

        .arrow {
            margin: 0 6px;
            color: #aeaeae;
        }

        > *:last-child {
            font-size: 16px;
            color: #000000;
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/mobile/bread.less"></style>
